var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "navi-blog-partner",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "navi-blog-partner-2",
    "data-name": "navi-blog-partner",
    d: "M17.708,0H2.292A2.294,2.294,0,0,0,0,2.292V17.708A2.294,2.294,0,0,0,2.292,20H17.708A2.294,2.294,0,0,0,20,17.708V2.292A2.294,2.294,0,0,0,17.708,0ZM13.333,14.167H6.667a.833.833,0,1,1,0-1.667h6.667a.833.833,0,1,1,0,1.667Zm0-3.333H6.667a.833.833,0,1,1,0-1.667h6.667a.833.833,0,1,1,0,1.667Zm0-3.333H6.667a.833.833,0,1,1,0-1.667h6.667a.833.833,0,1,1,0,1.667Zm0,0",
    fill: "#d6d6d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.61d8e4fd0d3a34a0a97b830c2b57159c.svg";
export { ForwardRef as ReactComponent };